import React from 'react'
import moment from 'moment'
import * as translationService from '../services/translationService'
import * as routeService from '../services/routeService'
import { Form, FormStepper, ButtonGroup, Button, PropertyBar } from './../components'
import RentIntentionScene from './scenes/RentIntentionScene'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { scroller } from 'react-scroll'

class RentIntentionView extends React.PureComponent {
  static propTypes = {
    step: PropTypes.any,
    property: PropTypes.object,
  }

  state = {
    dateToggle: '',
    startDate: moment(),
  }

  componentDidMount = () => {
    scroller.scrollTo('mainContent', {
      smooth: true,
    })
  }

  onRadioButtonChange = ({ target: { value, name } }) => {
    this.setState({
      [name]: value,
    })
  }

  rentIntentionSceneRef = {}

  onDateChange = (date, name) => {
    this.setState({ [name]: date })
  }
  goToPreviousFlow = () =>
    this.rentIntentionSceneRef
      .onSubmit(false)
      .then(() => {
        routeService.goToNextFlowPage(this.props.step, -1)
      })
      .catch(() => {})
  goToNextFlow = () =>
    this.rentIntentionSceneRef
      .onSubmit()
      .then(() => {
        routeService.goToNextFlowPage(this.props.step)
      })
      .catch(() => {})

  render() {
    const { property } = this.props
    return (
      <div>
        {property && <PropertyBar property={property} />}
        <FormStepper steps={routeService.getStepperRoutes(this.props.step, property.zip)} />
        <Form>
          <RentIntentionScene onRef={ref => (this.rentIntentionSceneRef = ref)} />
          <div>
            <ButtonGroup>
              <Button onClick={this.goToPreviousFlow}>{translationService.buttonPrevious()}</Button>
              <Button onClick={() => this.goToNextFlow()} primary>
                {translationService.buttonNext()}
              </Button>
            </ButtonGroup>
          </div>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = ({ FlowReducer }) => {
  const { step, property } = FlowReducer
  return {
    step,
    property,
  }
}

export default compose(connect(mapStateToProps))(RentIntentionView)



// WEBPACK FOOTER //
// ./src/views/RentIntentionView.js